<div class="padding_dialog">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-xs-12">
        <span class="stato_offline_span">Stampa in corso...</span>
      </div>
    </div>
    <div class="row padding-spinner">
      <div class="col-xs-12">
        <mat-progress-spinner class="spinner_print" [mode]="'indeterminate'"></mat-progress-spinner>
      </div>
    </div>
  </div>
</div>
